/* ==========================================================================
   PN 2.45 — 01.09.2026
   Ucretsiz kargo esigi asildiginda: sepeti ac + barayi bir kez parlat.

   NEDEN MutationObserver:
   Sepet degistiginde tema #mini-cart'in innerHTML'ini KOMPLE degistiriyor
   (Section Rendering API). Ustelik olay yayini eksik — cart:updated yalnizca
   adet degisiminde atiliyor, sepete ekleme yollarinin cogu (PDP formu,
   yapiskan cubuk formu, renk secici, hediye paketi) hicbir olay atmiyor.
   Bu yuzden tek guvenilir sinyal DOM'un kendisi.

   NEDEN DOM'dan okuyoruz, /cart.js'ten degil:
   Bara, hediye paketi tutarini sepet toplamindan DUSEREK hesapliyor
   (snippets/free-shipping.liquid). JS'te yeniden hesaplasak, sepette hediye
   paketi varken bara ile aramizda fark olusurdu. Temanin bastigi sonucu
   okumak her zaman tutarli.

   Esik asildi sinyali: .free-shipping__progress--success sinifinin varligi.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'pn_fs_reached';
  var CELEBRATE_CLASS = 'pn-fs-celebrate';
  var ANIM_MS = 1200;

  function readReached() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeReached(v) {
    try {
      sessionStorage.setItem(STORAGE_KEY, v ? '1' : '0');
    } catch (e) {
      /* depolama kapali olabilir */
    }
  }

  /* Sayfa acilisindaki mevcut durum. Sepet zaten esigin ustundeyse
     kutlama yapilmaz — yalnizca gecis anini kutluyoruz. */
  var wasReached = readReached();
  var celebrating = false;

  function barEl() {
    return document.querySelector('#mini-cart .free-shipping');
  }

  function isReached() {
    return !!document.querySelector(
      '#mini-cart .free-shipping__progress--success, #mini-cart .free-shipping__text--success'
    );
  }

  function openDrawer() {
    var mc = document.querySelector('mini-cart');
    if (!mc || typeof mc.open !== 'function') return;
    try {
      /* .open() zaten details[open] kontrolu yapiyor, tekrar cagirmak zararsiz. */
      mc.open();
    } catch (e) {
      /* cekmece acilamadiysa kutlama yine de gorunur olur */
    }
  }

  function celebrate() {
    var bar = barEl();
    if (!bar) return;

    bar.classList.remove(CELEBRATE_CLASS);
    /* reflow — ayni sinif art arda eklenirse animasyon yeniden bassin */
    void bar.offsetWidth;
    bar.classList.add(CELEBRATE_CLASS);

    celebrating = true;
    setTimeout(function () {
      celebrating = false;
      var b = barEl();
      if (b) b.classList.remove(CELEBRATE_CLASS);
    }, ANIM_MS);
  }

  function evaluate() {
    var bar = barEl();

    /* Bara henuz basilmadiysa (cekmece icerigi tembel yukleniyor) bekle. */
    if (!bar) return;

    var reached = isReached();

    if (reached && !wasReached) {
      wasReached = true;
      writeReached(true);
      openDrawer();
      /* Cekmece acilma animasyonu bitsin, sonra kutla. */
      setTimeout(celebrate, 260);
    } else if (!reached && wasReached) {
      /* Sepetten urun cikarildi, esigin altina dusuldu — bir sonraki
         gecis tekrar kutlanabilsin. */
      wasReached = false;
      writeReached(false);
    } else if (reached && !celebrating) {
      /* Yeniden basim sonrasi sinif kaybolmus olabilir; kutlama
         suresi disindaysa dokunma. */
    }
  }

  function observe() {
    var target = document.getElementById('mini-cart');
    if (!target) return false;

    new MutationObserver(function () {
      evaluate();
    }).observe(target, { childList: true, subtree: true });

    evaluate();
    return true;
  }

  function init() {
    if (!observe()) {
      /* #mini-cart header ile geliyor; yoksa bir kez daha dene. */
      document.addEventListener('cartdrawer:opened', observe, { once: true });
      window.addEventListener('load', observe, { once: true });
    }

    /* Adet degisimi tek olay yayan yol; gozlemciyi destekler. */
    document.addEventListener('cart:updated', evaluate);
    document.addEventListener('ajaxProduct:added', evaluate);
    document.addEventListener('cartdrawer:opened', evaluate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   PN 2.75 — 17.09.2026
   CARK KUPONUNU SEPETE OTOMATIK UYGULA

   NEDEN: WooHoo carki kodu yalnizca EKRANDA gosteriyor; "Simdi Uygula"
   butonu (.copy-code) aslinda sadece panoya kopyaliyor. Musteri kodu elle
   sepete yazmak zorunda kaliyordu. Clarity kayitlarinda kupon alanina
   girip birakan oturumlarin %61'i odeme adimina hic ulasmiyordu.

   KOD NEREDE: carkin alt barindaki gizli input — #copy-coupon.
   Bar kazanilana kadar display:none duruyor, kazanilinca input'a kod
   yaziliyor. input.value degisimi MutationObserver'a DUSMEZ (deger bir
   oznitelik degil), o yuzden kisa arali yoklama kullaniyoruz — tek bir
   input okumasi, olcumu alinamayacak kadar ucuz.

   GUVENLIK AGI: kod uygulandiktan sonra /cart.js'ten applicable alani
   DOGRULANIYOR. Uygulanamadiysa sepet eski koduna geri donduruluyor;
   yani carkin kodu, musterinin halihazirda gecerli olan kodunu
   sessizce dusuremez.

   BOS SEPET TUZAGI (17.09.2026, canlida yakalandi):
   Shopify BOS sepette HER kodu applicable:false raporlar — indirilecek bir
   sey yoktur. Kod yine de oturuma yazilir (discount_code cerezi) ve sepete
   urun girer girmez uygulanir. Ilk surum bunu BASARISIZLIK sayip kodu geri
   aliyordu; musteriler carki siteye girer girmez, sepet BOSKEN cevirdigi
   icin bu pratikte herkes icin bozuktu. Testlerde sepette hep urun oldugu
   icin fark edilmemisti.
   Dogru davranis: sepet bossa kodu BIRAK, "hazir" de, ve sepete urun
   eklenince dogrulayip onayla.
   ========================================================================== */
(function () {
  'use strict';

  var ANAHTAR = 'pn_cark_kod';
  var BEKLEYEN = 'pn_cark_bekleyen';
  var DESEN = /^[A-Za-z0-9][A-Za-z0-9._-]{2,29}$/;
  var ARALIK_MS = 1000;
  var AZAMI_SURE_MS = 15 * 60 * 1000;

  var basladi = Date.now();
  var mesgul = false;
  var sayac = null;
  /* Bekleyen kod sessionStorage'da tutuluyor: musteri carki anasayfada
     cevirip urun sayfasina gecebilir; bellekteki degisken o geciste
     kaybolurdu ve "urun ekleyince uygulanacak" sozu sessizce dusrerdi. */
  var bekleyenKod = (function () {
    try { return sessionStorage.getItem(BEKLEYEN) || null; } catch (e) { return null; }
  })();

  function bekleyenYaz(kod) {
    bekleyenKod = kod;
    try {
      if (kod) sessionStorage.setItem(BEKLEYEN, kod);
      else sessionStorage.removeItem(BEKLEYEN);
    } catch (e) {
      /* depolama kapali olabilir */
    }
  }

  function kodOku() {
    var alan = document.getElementById('copy-coupon');
    if (!alan) return '';
    var deger = (alan.value || '').trim();
    return DESEN.test(deger) ? deger : '';
  }

  function denendiMi(kod) {
    try {
      return (sessionStorage.getItem(ANAHTAR) || '').toUpperCase() === kod.toUpperCase();
    } catch (e) {
      return false;
    }
  }

  function denendiYaz(kod) {
    try {
      sessionStorage.setItem(ANAHTAR, kod);
    } catch (e) {
      /* depolama kapali olabilir */
    }
  }

  function sepetOku() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (y) {
      return y.json();
    });
  }

  function gecerliKodlar(sepet) {
    return (sepet.discount_codes || [])
      .filter(function (k) {
        return k.applicable;
      })
      .map(function (k) {
        return k.code;
      });
  }

  function kodlariYaz(kodlar) {
    var yol = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    return fetch(yol, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: kodlar.join(',') })
    });
  }

  /* Cekmece icerigini Section Rendering API ile tazele; boylece indirim
     satiri ve toplam, sayfa yenilenmeden guncel gorunur. */
  function cekmeceTazele() {
    return fetch('/?sections=mini-cart', { credentials: 'same-origin' })
      .then(function (y) {
        return y.json();
      })
      .then(function (paket) {
        var html = paket && paket['mini-cart'];
        var hedef = document.getElementById('mini-cart');
        if (!html || !hedef) return;
        var gecici = document.createElement('div');
        gecici.innerHTML = html;
        var kaynak = gecici.querySelector('#mini-cart');
        hedef.innerHTML = kaynak ? kaynak.innerHTML : html;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        /* tazeleme basarisiz olduysa indirim yine de sepette duruyor */
      });
  }

  function bildir(metin, basarili) {
    var eski = document.querySelector('[data-pn-cark-bildirim]');
    if (eski && eski.parentNode) eski.parentNode.removeChild(eski);

    var kutu = document.createElement('div');
    kutu.setAttribute('data-pn-cark-bildirim', '');
    kutu.setAttribute('role', 'status');
    kutu.setAttribute('aria-live', 'polite');
    kutu.textContent = metin;
    kutu.style.cssText = [
      /* USTTE duruyor: alt bolge bu sitede kalabalik — mobil dock, yapiskan
         sepet cubugu, sohbet dugmesi, cark sekmesi ve onizlemede Shopify'in
         kendi preview bar iframe'i hepsi orada. Ust bolgede yalnizca sticky
         header var, onu 9 saniye ortmek sorun degil. */
      'position:fixed',
      'left:16px',
      'right:16px',
      'top:12px',
      'z-index:2147483647',
      'max-width:420px',
      'margin:0 auto',
      'padding:12px 16px',
      'border-radius:12px',
      'background:' + (basarili ? '#1A1B18' : '#8A2B2B'),
      'color:#fff',
      'font-size:14px',
      'line-height:1.4',
      'text-align:center',
      'box-shadow:0 6px 24px rgba(0,0,0,.22)',
      'pointer-events:none'
    ].join(';');
    document.body.appendChild(kutu);

    setTimeout(function () {
      if (kutu.parentNode) kutu.parentNode.removeChild(kutu);
    }, 9000);
  }

  function uygula(kod) {
    if (mesgul || !kod || denendiMi(kod)) return;
    mesgul = true;
    denendiYaz(kod);

    var oncekiler = [];

    sepetOku()
      .then(function (sepet) {
        oncekiler = gecerliKodlar(sepet);
        return fetch('/discount/' + encodeURIComponent(kod), { credentials: 'same-origin' });
      })
      .then(function () {
        return sepetOku();
      })
      .then(function (sepet) {
        var kayit = (sepet.discount_codes || []).filter(function (k) {
          return (k.code || '').toLowerCase() === kod.toLowerCase();
        })[0];

        if (kayit && kayit.applicable) {
          /* Yoklama DURDURULMUYOR: musteri ayni sayfada ikinci kez cevirirse
             yeni kod da yakalanmali. Ayni kodun tekrar uygulanmasini
             denendiMi() zaten engelliyor; yoklama tek bir getElementById. */

          /* /cart sayfasinda yenileme yapiyoruz ve yenileme toast'i siler —
             tam da indirim barinda duzelttigimiz hatanin aynisi. Mesaji
             sakliyoruz; blocks/ai_gen_block_a973aaf.liquid yenilemeden
             sonra pn_discount_msg'i yesil olarak basiyor. */
          if (window.location.pathname.indexOf('/cart') === 0) {
            try {
              sessionStorage.setItem('pn_discount_msg', kod + ' kodu sepetine uygulandı.');
            } catch (e) {
              /* depolama kapaliysa toast'a dus */
            }
            bildir('🎉 Kodun sepetine uygulandı: ' + kod, true);
            window.location.reload();
            return null;
          }

          bildir('🎉 Kodun sepetine uygulandı: ' + kod, true);
          return cekmeceTazele();
        }

        /* SEPET BOS: applicable:false burada arizanin degil, bos sepetin
           sonucudur. Kod oturumda duruyor; geri ALMIYORUZ. */
        if (!sepet.item_count) {
          bekleyenYaz(kod);
          bildir('🎉 Kodun hazır: ' + kod + ' — sepetine ürün ekleyince uygulanacak.', true);
          return null;
        }

        /* Sepet dolu ve kod yine de gecerli degil — gercek uyumsuzluk.
           Musterinin onceki gecerli kodunu geri koy. */
        return kodlariYaz(oncekiler).then(function () {
          if (oncekiler.length) {
            bildir(kod + ' kodu şu an uygulanamadı; mevcut indirimin korundu.', false);
          } else {
            bildir(kod + ' kodu şu an sepetine uygulanamadı.', false);
          }
        });
      })
      .catch(function () {
        /* Ag hatasi: sessiz gec, musteri kodu elle de girebilir. */
      })
      .then(function () {
        mesgul = false;
      });
  }

  function durdur() {
    if (sayac) {
      clearInterval(sayac);
      sayac = null;
    }
  }

  function yokla() {
    if (Date.now() - basladi > AZAMI_SURE_MS) {
      durdur();
      return;
    }
    var kod = kodOku();
    if (kod) uygula(kod);
  }

  /* Bekleyen kod, sepete urun girdigi anda gercekten uygulandi mi? */
  function bekleyeniDogrula() {
    if (!bekleyenKod) return;
    sepetOku()
      .then(function (sepet) {
        if (!sepet.item_count) return;
        var k = (sepet.discount_codes || []).filter(function (d) {
          return (d.code || '').toLowerCase() === bekleyenKod.toLowerCase();
        })[0];
        if (k && k.applicable) {
          bildir('🎉 ' + bekleyenKod + ' kodun sepetine uygulandı.', true);
          bekleyenYaz(null);
        }
      })
      .catch(function () {});
  }

  function init() {
    sayac = setInterval(yokla, ARALIK_MS);
    yokla();

    /* SEPET DEGISIMINI OLAYLA DEGIL DOM'LA YAKALA.
       Bu temanin olay yayini eksik — bu dosyanin ust yarisindaki PN 2.45
       notunda yazili: cart:updated yalnizca adet degisiminde atiliyor,
       sepete ekleme yollarinin cogu hicbir olay atmiyor. Ilk surumde bu
       nota ragmen olaya guvendim ve onay bildirimi hic cikmadi (canlida
       olculdu: indirim uygulandi, bildirim yok). Tek guvenilir sinyal
       #mini-cart'in yeniden basilmasi. */
    var dogrulaZaman = null;
    function dogrulaSirala() {
      if (!bekleyenKod) return;
      clearTimeout(dogrulaZaman);
      dogrulaZaman = setTimeout(bekleyeniDogrula, 500);
    }

    function sepetiGozle() {
      var hedef = document.getElementById('mini-cart');
      if (!hedef) return false;
      new MutationObserver(dogrulaSirala).observe(hedef, { childList: true, subtree: true });
      return true;
    }

    if (!sepetiGozle()) {
      document.addEventListener('cartdrawer:opened', sepetiGozle, { once: true });
      window.addEventListener('load', sepetiGozle, { once: true });
    }

    /* Olaylar destekleyici olarak kalsin — atildiklarinda daha hizli. */
    document.addEventListener('ajaxProduct:added', dogrulaSirala);
    document.addEventListener('cart:updated', dogrulaSirala);
    document.addEventListener('cartdrawer:opened', dogrulaSirala);

    /* Gezinme sonrasi: sepet bu arada dolmus olabilir. */
    if (bekleyenKod) setTimeout(bekleyeniDogrula, 900);

    /* "Simdi Uygula" butonuna basildiginda beklemeden uygula. */
    document.addEventListener(
      'click',
      function (olay) {
        var hedef = olay.target;
        if (!hedef || !hedef.closest) return;
        if (hedef.closest('.copy-code')) setTimeout(yokla, 60);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
